import { useNotificationsContext } from './NotificationsContext';
import NotificationsList from './NotificationsList';
import { useEffect, useRef } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Modal } from '../components/Modal';
import { Bell } from 'lucide-react';

export default function Notifications() {
    const dropdownRef = useRef<HTMLDivElement>(null);
    const isMobile = useMediaQuery({ maxWidth: 768 });
    const {
        countNotVisualized,
        dropdownOpen,
        setDropdownOpen,
    } = useNotificationsContext();

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setDropdownOpen(false);
            }
        };
        if (dropdownOpen && !isMobile) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownOpen, isMobile, setDropdownOpen]);

    return (
        <div className="relative" ref={dropdownRef}>
            <div className="indicator">
                {countNotVisualized > 0 && (
                    <span className="indicator-item sf-unread-dot" aria-hidden="true" />
                )}
                <button
                    className="sf-mobile-toolbar-button sf-icon-button btn btn-circle btn-sm"
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    aria-label={`Abrir notificações${countNotVisualized > 0 ? `, ${countNotVisualized} não lidas` : ''}`}
                >
                    <Bell aria-hidden="true" />
                </button>
            </div>
            {dropdownOpen && isMobile && (
                <Modal title="Notificações" onClose={() => setDropdownOpen(false)}>
                    <NotificationsList />
                </Modal>
            )}
            {dropdownOpen && !isMobile && (
                <div className="sf-overlay-panel absolute right-0 z-50 mt-4 max-h-[70vh] w-[min(92vw,24rem)] overflow-y-auto rounded-[1.5rem] text-base-content">
                    <div className="p-4">
                        <NotificationsList title="Notificações" />
                    </div>
                </div>
            )}
        </div>
    );
}
